import { Vector } from './Vector'

export class Physics {
    static NewVelocity(initialVelocity: Vector, acceleration: Vector, time: number) {
        return Vector.add(Vector.scale(acceleration, time), initialVelocity);
    }

    /// <summary>
    /// s=ut+(1/2)at^2
    /// where a = 0
    /// s = ut
    ///
    /// </summary>
    static NewPosition(initialPosition: Vector, initialVelocity: Vector, acceleration: Vector, time: number) {
        return Vector.add(Vector.add(Vector.scale(Vector.scale(acceleration, 0.5), time * time),
            Vector.scale(initialVelocity, time)), initialPosition);
    }
}